<template>
    <div class="innerBox">
  
      <h1>Kas Kecil</h1>
  
      <panel class="border border-secondary" :noExpand="true">
        <template slot="header">
          <h4 class="panel-title">Filter</h4>
        </template>
        <div class="row outerBox filterBox" style="padding:0">
          <div class="col row">
            <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
                <label>Cari</label>
                <!-- <MultiSelect
                  v-model="filter.labourer_id"
                  :options="options.laborer.map(type => type.id)"
                  :custom-label="opt => options.laborer.find(x => x.id == opt).name"
                  placeholder="Pilih Pekerja"
                ></MultiSelect> -->
                <input
                  type="text"
                  class="form-control"
                  v-on:keyup.enter="vue_universal_table.update++"
                  placeholder="Ketik teks"
                  style="height: 43px;"
                  v-model="filter.search"
                />
            </div>
            <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
              <label>Tanggal</label>
              <flat-pickr
                v-model="selected.date"
                :config="rangeConfig"
                placeholder="Pilih Tanggal"
              ></flat-pickr>
            </div>
            <div class="col-md-4" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
              <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
            </div>
          </div>
        </div>
      </panel>
      
      <div class="row mt-3 mb-3">
        <div class="col-lg-6 col-12 mb-2">
          <smallStats 
            title="Total Debit"
            :value="
              report
                ? 'Rp. ' + 
                numberWithCommas(
                    parseFloat(report.debit)
                )
                : 'Loading...'
            "
            background_color="#2ea34b"
            icon="money-check"
            text_color="#fff"
          />
        </div>
        <div class="col-lg-6 col-12 mb-2">
          <smallStats 
            title="Total Credit"
            :value="
              report
                ? 'Rp. ' + 
                numberWithCommas(
                    parseFloat(report.credit)
                )
                : 'Loading...'
            "
            background_color="#FF5733"
            icon="receipt"
            text_color="#fff"
          />
        </div>
      </div>
  
      <vue-universal-table
        api_url="/api/v1/treasury/petty-cash"
        :buttons="vue_universal_table.buttons"
        :fields="vue_universal_table.fields"
        :indexing="true"
        :special_buttons="vue_universal_table.special_buttons"
        :update="vue_universal_table.update"
        :filter="filter"
        :process_data="vue_universal_table.process_data"
        :export_config="vue_universal_table.export_config"
        @onViewImage="viewImage"
      ></vue-universal-table>
  
      <preview-image
        v-if="modal.previewImage"
        :image="imageView"
        @closeModal="modal.previewImage = false"
      ></preview-image>

    </div>
  </template>
  
  <script>
    import previewImage from '@/components/modal/previewImage'
    import env from '@/env'
    import qs from 'qs'
    import smallStats from '@/components/smallStats'

    export default {
      data () {
        return {
          mobile : this.isMobile(),
          modal : {
            previewImage : false,
          },
          imageView : null,
          rangeConfig: {
            mode: 'range',
            altInput: true,
            altInputClass: 'form-control input flatpickr-input w-100',
            animate: !this.isRTL()
          },
          options : {
            laborer : null,
          },
          selected : {
            date : '',
          },
          filter : {
            search : ''
          },
          report : null,
          vue_universal_table : {
            fields : [
                {
                    title : 'Deskripsi Pembelian',
                    variable : 'deskripsi_pembelian'
                },
                {
                    title : 'Debit',
                    variable : 'debit',
                    number_formatting : true
                },
                {
                    title : 'Credit',
                    variable : 'credit',
                    number_formatting : true
                },
                {
                    title : 'Tanggal Tercatat',
                    variable : 'tanggal_tercatat'
                }
            ],
            buttons : [
                {
                    title : 'viewImage',
                    class : 'fas fa-image btn-outline-primary',
                    variable : 'attachment'
                }
            ],
            special_buttons : ['exportToExcel'],
            update : 0,
            export_config : {
              name : 'Kas Kecil',
              type : 'xlsx',
              all : true
            },
          },
        }
      },
      components : {
        previewImage,
        smallStats
      },
      mounted () {
        this.fetchReport();
      },
      watch : {
        'selected.date'(){
          var date = this.selected.date.split(" to ");
          this.filter.start = date[0]
          this.filter.end = date[1]
        },
        'vue_universal_table.update' : function () {
          this.fetchReport()
        }
      },
      methods : {
        viewImage(a){
          a = a.split('"').join('')
          this.modal.previewImage = true;
          this.imageView = env.baseImage + '/' + a;
        },
        fetchReport () {
          this.$http.get(`/api/v1/treasury/petty-cash-report?${qs.stringify(this.filter)}`)
          .then((resp)=>{
            this.report = resp.data.data
          })
          .catch((err)=>{console.log(err)})
        },
      }
    }
  </script>
  
  <style scoped>
  
  </style>